import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken , clearUserCache } from '@/utils/auth'
import router from '@/router'

// 创建axios实例
const service = axios.create({
  responseType: 'json',
  baseURL: process.env.BASE_API,
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  let token = getToken()
  if (token) {
    config.headers['token'] = token // 携带token
  } else {
    router.push({ 'path': '/login' })
  }
  return config
}, error => {
  Promise.reject(error)
})

// response拦截器
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    // 判断token是否过期
    if (error.response.status === 401) {
      clearUserCache()
      router.push({ 'path': '/login' })
    } else {
      Message({
        message: error.response.data.msg,
        type: 'warning',
        duration: 1000+100*(error.response.data.msg?error.response.data.msg.length:0)
      })
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js